const OB_TOKENS_COOKIE = 'ob_tokens'
const MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000 // 14 days

type EstablishmentSession = {
  token: string
  email: string
  issuedAt: number
}

type SessionMap = Record<string, EstablishmentSession>

function decodeCookie(encoded: string): SessionMap {
  try {
    const json = atob(encoded)
    return JSON.parse(json) as SessionMap
  } catch {
    return {}
  }
}

function readCookie(): string | null {
  if (typeof document === 'undefined') return null
  const prefix = `${OB_TOKENS_COOKIE}=`
  const cookie = document.cookie
    .split('; ')
    .find((c) => c.startsWith(prefix))
  if (!cookie) return null
  return decodeURIComponent(cookie.slice(prefix.length))
}

function isExpired(session: EstablishmentSession): boolean {
  return Date.now() - session.issuedAt > MAX_AGE_MS
}

export type CustomerSession = {
  token: string
  email: string
}

export function getCustomerSession(
  establishmentId: string,
): CustomerSession | null {
  const raw = readCookie()
  if (!raw) return null

  const sessionMap = decodeCookie(raw)
  const entry = sessionMap[establishmentId]
  if (!entry) return null
  if (isExpired(entry)) return null

  return { token: entry.token, email: entry.email }
}

export function getCustomerSessionToken(
  establishmentId: string,
): string | null {
  return getCustomerSession(establishmentId)?.token ?? null
}

export function isAuthenticated(establishmentId: string): boolean {
  return getCustomerSession(establishmentId) !== null
}
